import Cookies from "js-cookie";

const COOKIE_NAME = "albelli_qty";

/**
 * The Albelli Qty Cookie is used for a holiday hack to allow the Product Page
 * to pass the QTY Selection to the PDC page.  This solution has many edge cases
 * that are not supported, however the primary use cases are sufficient for a temporary patch
 * over holiday 2023 and post holiday a real solution will be put into place and this solution removed.
 */
export default class AlbelliQtyCookieProvider {
  static setAlbelliQty(qty: number): void {
    Cookies.set(COOKIE_NAME, qty.toString(), { expires: 1 });
  }

  static getAlbelliQty(): number | undefined {
    const unsanitizedQty = Cookies.get(COOKIE_NAME);
    if (unsanitizedQty) {
      try {
        const sanitizedQty = parseInt(unsanitizedQty);
        return sanitizedQty;
      } catch {
        // If a non-number is placed into the cookie,
        // remove the cookie entirely to return to the supported 'base' experience
        AlbelliQtyCookieProvider.deleteAlbelliQty();
      }
    }
    return undefined;
  }

  static deleteAlbelliQty(): void {
    Cookies.remove(COOKIE_NAME);
  }
}
